export default class NodoOpl {
    constructor() {
        this.tipo = undefined
        this.operadores = []
        this.nodos = []

        this.regla = undefined
        this.cumple = "IS";
    }
}